import React, { useEffect, useState } from 'react';

import { Image, Input, Spinner } from '../../../../ui';

import { ICard } from './RadioOptions';
import {
  AddImage,
  DeleteButton,
  ImageContainer,
  ImageWrapper,
  OptionBox,
} from './RadioOptionsElements';

export const RadioOptions: React.FC<ICard.IProps> = (props) => {
  const [index, setIndex] = useState(-1);

  useEffect(() => {
    props.defects.map((v, i) => v.has_defect && setIndex(i));
  }, [props.defects]);

  const onChangeOption = (i: number) => {
    if (i === index) {
      props.onRemoveOption(props.defects[i]);
      setIndex(-1);
    } else {
      setIndex(i);
    }
  };

  return (
    <>
      {props.defects.map((defItem, i) => (
        <OptionBox
          key={defItem.defect.slug}
          color={defItem.severity_text}
          onClick={() => onChangeOption(i)}
        >
          {index === i ? (
            <span className="icon-Checkbox-and-Radio-Buttons">
              <span className="path1" />
              <span className="path2" />
              <span className="path3" />
            </span>
          ) : (
            <span className="icon-Checkbox-and-Radio-Buttons1" />
          )}
          <label>{defItem.defect.name}</label>
        </OptionBox>
      ))}
      {index !== -1 && (
        <>
          <Input
            label={'Description'}
            value={props.defects[index].note}
            onFocus={() => props.onFocusInput(props.defects[index])}
            onBlur={(v) => props.onBlurInput(v.currentTarget.value)}
          />
          <ImageContainer>
            <AddImage
              className={
                props.isLoadingPatchDefect && props.defectSlug === props.defects[index].defect.slug
                  ? ''
                  : 'icon-u_camera-plus'
              }
              onClick={() => props.onClickAddImage(props.defects[index])}
            >
              <Spinner
                isLoading={
                  props.isLoadingPatchDefect &&
                  props.defectSlug === props.defects[index].defect.slug
                }
              />
            </AddImage>
            {props.defects[index].images?.map((image) => (
              <ImageWrapper key={image.uuid}>
                <Image src={image.url} height={128} width={128} />
                <DeleteButton
                  className={'icon-u_trash-alt'}
                  onClick={() => props.onClickRemoveImage(image.uuid)}
                />
              </ImageWrapper>
            ))}
          </ImageContainer>
        </>
      )}
    </>
  );
};
